import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import communityGardenMaterialListAction from './communityGardenMaterialList.action.json' with { type: 'json' }
import { communityGardenMaterialObject } from '../../communityGardenMaterialObject'

export const communityGardenMaterialExpression = expression(communityGardenMaterialObject.shape)

const communityGardenMaterialListDefinition = defineAction({
  ...communityGardenMaterialListAction,

  input: z.object({
    filter: communityGardenMaterialExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      quantity: 'Quantidade',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({ items: z.array(communityGardenMaterialObject), count: z.number() }),
})

export default communityGardenMaterialListDefinition
